 <template>
  <el-row class="el-row_h">
    <el-col :span="24">
      <div class="grid-content bg-purple-dark layout_box flex s_bg" style="overflow-x: auto">
        <el-input placeholder="请输入用户关键字搜索" v-model="keyWord" clearable size="small" class="s_padding filterSelect" style="min-width:200px;">
        </el-input>
        <!-- <el-input placeholder="请输入品种关键字搜索" v-model="CommodityVal" clearable size="small" class="s_padding filterSelect">
        </el-input> -->
        <el-select style="min-width:150px;" v-model="CommodityVal" size="small" multiple collapse-tags placeholder="请选择品种" class="s_padding">
          <el-option v-for="item in CommodityVals" :key="item.Code" :label="item.Name" :value="item.Code">
          </el-option>
        </el-select>
        <el-select v-model="PositionEffectValue" size="small" placeholder="请选择" class="s_padding" style="width:80px;min-width:80px;">
          <el-option v-for="item in PositionEffectList" :key="item.Code" :label="item.Name" :value="item.Code">
          </el-option>
        </el-select>
        <el-select v-model="sortType" size="small" placeholder="请选择排序方式" class="s_padding" style="width:100px;min-width:150px;">
          <el-option v-for="item in sortTypes" :key="item.Code" :label="item.label" :value="item.Code">
          </el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-search" size="small" @click="getList()">查询</el-button>
      </div>
      <div style="height: 100%;">
        <tableCom :data="delegateList" v-loading="loading"></tableCom>
      </div>
      <div class="pagination_mb2 text-center">
        <pagination :pagerPro="Pager" @ee="pageFn"></pagination>
      </div>
      <div class="footer grid-content bg-purple layout_box">
        <span class="text-right">
          单量合计:
          <span class="capital">{{totalCapital}}</span>
          &nbsp;&nbsp;&nbsp; 手续费合计:
          <span class="capital">{{totalCommission}}</span>
          <span class="Currency"> ({{CurrencyName}})</span>
          &nbsp;&nbsp;&nbsp; 平仓盈亏:
          <span class="capital">{{totalCurrency}}</span>
          <span class="Currency"> ({{CurrencyName}})</span>
        </span>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import tableCom from "./StatisticsOrderT.vue";
import pagination from "../../../paging.vue";
import dateRange from "../../../dateRangeSub.vue";

export default {
  // 筛选器
  name: "positionDetailS",
  components: {
    tableCom,
    pagination,
    dateRange
  },
  props: ["agentID"],
  data() {
    return {
      loading: "",
      sortType: 0,
      sortTypes: [
        { Code: 0, label: "单量升序" },
        { Code: 1, label: "单量降序" },
        { Code: 2, label: "盈亏升序" },
        { Code: 3, label: "盈亏降序" }
      ],
      Pager: {
        PageNo: 1,
        PageSize: 10,
        RecordCount: 0
      },
      delegateList: [],
      totalCapital: 0,
      totalCurrency: 0,
      totalCommission: 0,
      keyWord: "",
      CommodityVal: [],
      CommodityVals: [],
      PositionEffectValue: 0,
      PositionEffectList: [
        { Code: 0, Name: "全部" },
        { Code: 1, Name: "开仓" },
        { Code: 2, Name: "平仓" },
        { Code: 3, Name: "平开" }
      ],
      queryobj:{},
      CurrencyName: '',
    };
  },
  mounted() {
    this.QueryComm();
    this.getList();
    this.getCurrencyName();
  },
  methods: {
    getCurrencyName() {
      var url = "/Account/GetInsBasicCurrency";
      var post = "";
      this.$loginapi.post(url, post, response => {
        if (response.Ret == 0) {
          this.CurrencyName = response.Data.Name;
        } else {
          this.$alert(response.Msg, {});
        }
      });
    },
    getList(isSearch = true) {
      if (isSearch) {
        this.Pager = {
          PageNo: 1,
          PageSize: 20,
          RecordCount: 0
        };
      }
      this.queryobj={
        UserKey:this.keyWord,
        SortType: this.sortType,
        Commodity: this.CommodityVal,
        PositionEffect: this.PositionEffectValue
      }
      this.$emit("order", this.queryobj);
      this.loading = true;
      let url = "/mycustomer/QryAgentCurrentTradeVolume";
      let postData = {
        AgentIds: this.agentID,
        UserKey: this.keyWord,
        SortType: this.sortType,
        Commodity: this.CommodityVal,
        PositionEffect: this.PositionEffectValue
      };
      this.$loginapi.postWithPage(
        url,
        this.Pager.PageNo,
        this.Pager.PageSize,
        postData,
        response => {
          this.loading = false;
          if (response.Ret == 0) {
            this.delegateList = response.Data.Records;
            this.totalCapital = response.Data.Volume;
            this.totalCommission = response.Data.Commission;
            this.totalCurrency = response.Data.CloseProfit;

            if (this.Pager.PageNo == 1) {
              this.Pager = response.Pager;
            }
          } else {
            this.$message.error(response.Msg);
          }
        }
      );
    },
    pageFn(size, PageNo) {
      this.Pager.PageSize = size;
      this.Pager.PageNo = PageNo;
      this.getList(false);
    },
    QueryComm() {
      let url = "/common/GetCommodityList";
      this.$loginapi.postwithouttoken(url, "", response => {
        if (response.Ret == 0) {
          this.CommodityVals = response.Data;
        } else {
          this.$message.error(response.Msg);
        }
      });
    }
  }
};
</script>

<style scoped>
.pagination_m {
  /* bottom: 20px !important; */
}
</style>



// WEBPACK FOOTER //
// src/components/selects/staticsToday/StatisticsOrder/StatisticsOrderS.vue